/**
 * 청크 로드 실패 자동복구(ZEP-655) 상수.
 *
 * 배경/설계 근거는 Linear ZEP-655 및 apps/quiz-app/infra/cloudfront/README.md 참고.
 * 핵심만: EKS 셀프호스팅은 "이미지가 곧 에셋"이라 Vercel 이 구 에셋을 서빙해 주던
 * 안전망이 없다 → weight 0 롤백/SWR 배포 순간 이미 열린 탭이 사라진 buildId 청크를
 * 요청해 404 백지가 된다. 복구 엔진은 _document 인라인 스크립트 하나다: 부팅 전 청크
 * 실패를 잡아 **cache-bust 리로드(확실히 새 버전) 1회 → 실패 시 포기**로 처리한다.
 */

/** sessionStorage 키. 값은 `{ buildId, count }` JSON. */
export const CHUNK_RECOVERY_STORAGE_KEY = 'zep_chunk_recovery_attempts';

/**
 * 부팅 전(_document 인라인 스크립트)에서 잡은 복구 결과를 다음 부팅으로 넘기는 sessionStorage 키.
 * 값은 `{ buildId, stage, message }`. 인라인 스크립트는 Sentry 가 아직 없어 직접 보고를 못 하므로,
 * 여기에 적어두면 다음에 앱이 뜰 때 훅이 읽어 Sentry 로 flush 한다. (리로드에 전송이 취소되지 않음)
 */
export const CHUNK_RECOVERY_PENDING_KEY = 'zep_chunk_recovery_pending';

/**
 * "앱이 부팅(interactive)됐다"를 인라인 스크립트에 알리는 window 플래그명.
 * 부팅됨 = 하이드레이션 성공 = 화면 멀쩡 → 인라인은 이 플래그가 서면 손을 뗀다(멀쩡한
 * 페이지를 리로드해 편집 중 미저장 초안을 날리지 않기 위해). 부팅 전 실패에만 개입한다.
 */
export const CHUNK_RECOVERY_BOOTED_FLAG = '__zepChunkRecoveryBooted';

/**
 * 캐시버스트용 쿼리 파라미터. 값은 **배포 식별자(commit SHA, _document 가 리터럴 주입)**.
 * CF 캐시 정책은 이 파라미터가 붙은 요청을 **캐시하지 말고 오리진 패스스루**해야 한다
 * (그래야 항상 현재 빌드 HTML 을 받고, 결정적 키의 pre-warm 오염도 없음 — README 🔴).
 * 값은 캐시 공유용이 아니라 **로그 식별용**(어느 빌드가 깨졌나) + 무한루프 캡(hasBust)용이다.
 */
export const CHUNK_RECOVERY_QUERY_PARAM = '__chunk_recovery';

/**
 * 복구 리로드 상한 = 1. cache-bust 리로드를 딱 1회만 시도하고, 그래도 깨지면 **포기**한다.
 * cache-bust 값이 buildId 라 결정적 → 재시도해도 같은 결과라 반복은 무의미(무한 새로고침만
 * 됨). "cache-bust 1회 → 포기". 그래도 깨진다 = 새 버전 자체가 결함이거나 CF 미반영 신호.
 */
export const MAX_CHUNK_RECOVERY_ATTEMPTS = 1;
